(function(){
  var root=document.getElementById('sbrev-root');if(!root)return;
  var q=root.querySelector('#sbrev-q'),count=root.querySelector('#sbrev-count'),
      chips=[].slice.call(root.querySelectorAll('.sbrev-chip')),
      cards=[].slice.call(root.querySelectorAll('.sbrev-card')),
      sections=[].slice.call(root.querySelectorAll('.sbrev-cat')),
      nores=root.querySelector('#sbrev-noresults'),
      total=cards.length,activeCat='all',deb;
  cards.forEach(function(c){c._t=c.textContent.toLowerCase()});
  function apply(){
    var term=q.value.trim().toLowerCase(),shown=0;
    cards.forEach(function(c){
      var okCat=activeCat==='all'||c.closest('.sbrev-cat').id===activeCat;
      var okTerm=!term||c._t.indexOf(term)>-1;var vis=okCat&&okTerm;
      c.style.display=vis?'':'none';if(vis)shown++;
    });
    sections.forEach(function(s){s.style.display=s.querySelector('.sbrev-card:not([style*="display: none"])')?'':'none'});
    nores.hidden=shown>0;
    count.textContent=shown===total?total.toLocaleString()+' reviews':shown.toLocaleString()+' of '+total.toLocaleString();
  }
  q.addEventListener('input',function(){clearTimeout(deb);deb=setTimeout(apply,110)});
  chips.forEach(function(ch){ch.addEventListener('click',function(){
    chips.forEach(function(x){x.classList.remove('sbrev-active')});ch.classList.add('sbrev-active');
    activeCat=ch.getAttribute('data-filter');apply();
    if(activeCat!=='all'){var el=root.querySelector('#'+activeCat);
      if(el){window.scrollTo({top:el.getBoundingClientRect().top+window.pageYOffset-150,behavior:'smooth'})}}
  })});
  var tt=root.querySelector('#sbrev-totop');
  window.addEventListener('scroll',function(){tt.classList.toggle('sbrev-show',window.pageYOffset>700)},{passive:true});
  tt.addEventListener('click',function(){window.scrollTo({top:0,behavior:'smooth'})});
  apply();
})();